import { projects } from "../../data/resume";

function Projects() {
    return (
        <section id="projects" className="section">
            <div className="container">
                <div className="section-header">
                    <p className="section-eyebrow">What I've built</p>
                    <h2 className="section-title">Projects &amp; Impact</h2>
                </div>
                <div className="projects-grid">
                    {projects.map((project) => (
                        <div className="project-card" key={project.name}>
                            <div className="project-card-header">
                                <h3>{project.name}</h3>
                                <span>{project.time}</span>
                            </div>
                            <ul>
                                {project.bullets.map((bullet, index) => (
                                    <li key={index}>{bullet}</li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default Projects;
